import { HasClassName } from '~/types/HasClassName';
import { HasStyle } from '~/types/HasStyle';
import { PropsWithChildren } from 'react';
import styles from './Heading.module.css';
import classNames from 'classnames';

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type Props = PropsWithChildren &
  HasClassName &
  HasStyle & {
    as?: HeadingTag;
  };

export function Heading({ children, className, style, as: Component = 'h1' }: Props) {
  return (
    <Component className={classNames(styles.heading, className)} style={style}>
      {children}
    </Component>
  );
}
